/**
 * Created by mac on 3/3/24
 */

AdsLimits.TYPES.MEDAL_COLLECTION = "medal";
if (!cleverapps.config.adslimits[AdsLimits.TYPES.MEDAL_COLLECTION]) {
    throw new Error("Ads limit for medal collection is not defined");
}

DataLoader.TYPES.MEDAL_COLLECTION = "_medal_collection";

Reward.register("medals", {
    getIcon: function () {
        return bundles.reward_icons.frames.medal_png;
    },

    receive: function (value) {
        aisensia.medalCollection.addMore(value);
    }
});
